import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";
import {Sound} from "../sound/Sound";

export class XMentalOutroRunner implements SimplePresentation {
    shouldRun(): boolean {
        return Game.model.gameData.mode === GameFeatureMode.RESPIN && Game.model.gameData.nextMode === GameFeatureMode.NORMAL && !Game.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        controller.setSkipCallback(undefined);
        if (Game.model.gameData.totalSpinWinnings === 0) {
            Game.soundPlayer.playSound(Sound.X_MENTAL_END);
        }
        tl.add(gsap.to(this, {duration: Game.model.gameData.totalSpinWinnings === 0 ? 0 : 1}));
        tl.add(() => {
            //Game.soundPlayer.switchMusic(GameFeatureMode.NORMAL);
            Game.soundPlayer.stopXMentalSpinLoop(Game.model.isBigWin);
        });
        tl.add([
            () => {
                Game.soundPlayer.playSound(Sound.IDLE_FLICKERS[0]);
            },
            Game.backgroundElements.glitchReSpinToMain()
        ]);
        tl.add(() => this.closeCallback(controller))
    }

    private closeCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

}